<template>
  <section class="overflow-auto pretty-scroll-theme">
    <iframe :src="statisticsUrl" class="w-100" style="height: 700px"></iframe>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Statistics",
  props: {
    statisticsUrl: {
      type: String,
      required: true,
    },
  },
});
</script>
